import api from '@api/routes/cart/addline';
import ReactiveComponent, { computed, filter, watch } from "@utils/reactive-component";
import AjaxLoader from '../ajax-loader/ajax-loader';
import template from './templates/pdp-add-to-cart';
import { defaults } from './pdp-mappings';
import cartStore from '@stores/cart/cart-store';

const parsedTemplate = $.parseHTML(template);

const CLASS_NAME_DISABLED = 'disabled';

const EVENT_KEY = `_addToCart_`;
const EVENT_CLICK = `click.${EVENT_KEY}`;
const EVENT_CHANGE = `change.${EVENT_KEY}`;

const DEFAULT_OPTIONS = {
    purchaseType: null,
    quantity: 1,
    variantId: 0,
    backOrdered: false
};

export default class PdpAddToCart extends ReactiveComponent {
    constructor($el, labels, options) {
        super();

        options = {
            ...DEFAULT_OPTIONS,
            ...options
        };

        $el.replaceWith(parsedTemplate);
        this.$el = $(parsedTemplate);

        this.$cartLabel = this.$el.find('[data-label="cart"]');
        this.$favoriteLabel = this.$el.find('[data-label="favorite"]');
        this.$purchaseLabel = this.$el.find('[data-label="purchase"]');
        this.$subscribeLabel = this.$el.find('[data-label="subscribe"]');
        this.$outofstockLabel = this.$el.find('[data-label="outofstock"]');
        this.$outofstockIcon = this.$el.find('[data-label="outofstockicon"]');
        this.$outofstockRegion = this.$el.find('[data-region="outofstockregion"]');

        this.$success = this.$el.find('[data-region="success"]');
        this.$error = this.$el.find('[data-region="error"]');

        this.$cartCtrl = this.$el.find('[data-control="cart"]');
        this.$radioCtrl = this.$el.find('[data-control="radio"]');

        this.$loaderPlaceholder = this.$el.find('[data-placeholder="loader"]');

        this.loader = null;

        this.catalogName = options.catalogName || 'VCA_Master';
        this.displayName = options.displayName;
        this.exceptionAmount = options.exceptionAmount ?? 0,
        this.exceptionBehavior = options.exceptionBehavior || null,
        this.productId = options.productId;
        
        this.labels = {
            ...defaults,
            ...labels
        };

        const radioValue = this.$radioCtrl.filter(':checked').val();

        this.reactive({
            loading: false,
            quantity: options.quantity,
            variantId: options.variantId,
            backOrdered: options.backOrdered,
            radioValue: Number(radioValue) ?? radioValue
        });

        this.init();
    }

    [computed]() {
        return {
            isBackOrdered() {
                return this.backOrdered
            },
            enabled() {
                const radioValue = this.radioValue ?? null;
                const validPayload = !!(this.quantity && radioValue !== null && this.variantId && !this.backOrdered);
                return validPayload && !this.loading;
            }
        }
    }

    [filter]() {
        return {
            radioValue(newValue) {
                return Number(newValue) ?? newValue;
            }
        }
    }

    [watch]() {
        return {
            enabled: this.updateState,
            loading: this.updateLoadingState
        }
    }

    init() {
        this.renderLabels();
        this.renderLoader();
        this.setupListeners();
        this.updateState();
    }

    async onCartClick() {
        if(this.enabled) {
            this.loading = true;

            const options = {
                autoshipFrequency: this.radioValue,
                catalogName: this.catalogName,
                exceptionAmount: this.exceptionAmount,
                exceptionBehavior: this.exceptionBehavior,
                quantity: this.quantity
            };

            if(this.$cartCtrl.closest('#pdpQuickview').length > 0){
                $('#quickshop-modal').modal('hide');
                $('div[data-region="main"]').slick('unslick');
                $('div[data-region="nav"]').slick('unslick');
            }

            const { error, success } = await cartStore.actions.addLine(this.productId, this.variantId, options);

            if(success) {
                cartStore.actions.focusMiniCart({
                    productId: this.productId,
                    variantId: this.variantId
                });
            } else {
                this.$error.html(error);
                this.$error.show();
            }
            this.loading = false;
        }
    }

    onRadioChange(evt) {
        this.radioValue = evt.target.value;
    }

    renderLabels() {
        this.$cartLabel.html(this.labels.AddToCart);
        this.$favoriteLabel.html(this.labels.FavoritesSrText);
        this.$purchaseLabel.html(this.labels.OneTimePurchase);
        this.$subscribeLabel.html(this.labels.Subscribe);
        this.$outofstockLabel.html(this.labels.OutOfStock);
        let img = document.createElement('img');
        img.src = this.labels.OutOfStockIcon;
        this.$outofstockIcon.html(img);
    }

    renderLoader() {
        this.loader = new AjaxLoader(this.$loaderPlaceholder, { size: 'xs' });
        this.loader.render();
    }

    setQuantity(quantity) {
        this.quantity = quantity;
    }

    setVariant({ exceptionAmount, exceptionBehavior, variantId, backOrdered }) {
        this.exceptionAmount = exceptionAmount ?? 0;
        this.exceptionBehavior = exceptionBehavior ?? null;
        this.variantId = variantId;
        if(this.variantId == null){
            this.backOrdered = false;
        }else{
            this.backOrdered = backOrdered;
        }
    }

    setupListeners() {
        this.$cartCtrl.on(EVENT_CLICK, () => this.onCartClick());
        this.$radioCtrl.on(EVENT_CHANGE, evt => this.onRadioChange(evt));
    }

    updateLoadingState() {
        if(this.loading) {
            this.$error.hide();
            this.$success.hide();
        }

        this.loader.active = this.loading;
        this.updateState();
    }

    updateState() {
        this.$cartCtrl.attr('aria-disabled', !this.enabled);
        if(this.isBackOrdered) {
            this.$outofstockRegion.show();
        }else{
            this.$outofstockRegion.hide();
        }

        if(this.enabled) {
            this.$cartCtrl.removeClass(CLASS_NAME_DISABLED);
        } else {
            this.$cartCtrl.addClass(CLASS_NAME_DISABLED);
        }
    }
}
